import {
  Form,
  Select,
} from 'antd'
import React from 'react'

import { selectCreatorOptions } from '@/redux/creator-selector'
import { useAppSelector } from '@/redux/utils'
import filterOptionsWithStatus from '@/utils/filter-options'

export function CreatorsFilterFields({ creatorIds }: {
  creatorIds: number[]
}) {
  const creatorOptions = useAppSelector(selectCreatorOptions)
  return (
    <Form.Item name="creatorIds" label={'Filter by Creator(s)'}>
      <Select
        mode="multiple"
        placeholder="Select creator"
        options={filterOptionsWithStatus(creatorOptions, creatorIds)}
        allowClear
      />
    </Form.Item>
  )
}
